import { render, staticRenderFns } from "./zhengshu.vue?vue&type=template&id=1d4e310c&scoped=true&"
import script from "./zhengshu.vue?vue&type=script&lang=js&"
export * from "./zhengshu.vue?vue&type=script&lang=js&"
import style0 from "./zhengshu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./zhengshu.vue?vue&type=style&index=1&id=1d4e310c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e310c",
  null
  
)

export default component.exports